import {
    AnotherKPIOperand,
    ConditionalOperand,
    Constant,
    DashboardFilterOperand,
    DateAddBusinessFunctionOperand,
    DateDiffBusinessFunctionOperand,
    FieldOperand,
    IsBusinessDateFunctionOperand,
    KnownVariable,
    MathExpression,
    NewVariableOperand,
    NullOperand,
    Operator,
    ParameterOperand,
    RFunctionOperand,
    SpecialAggregationFunctionOperand,
    SQLFunctionOperand,
    StoredConstant,
    UserFilterOperand,
    WhereInOperand
} from '@InstanceFactory';

export class StatementVisitorBase {
    public accept(statementPart): void {
        if (!statementPart) {
            throw new Error('statementPart cannot be empty');
        }
        if (!statementPart.$type) {
            throw new Error('statementPart must have defined $type');
        }

        switch (statementPart.$type) {
            case MathExpression.typeName:
                this.visitMath(statementPart);
                break;
            case WhereInOperand.typeName:
                this.visitWhereIn(statementPart);
                break;
            case SQLFunctionOperand.typeName:
                this.visitSqlFunction(statementPart);
                break;
            case FieldOperand.typeName:
                this.visitField(statementPart);
                break;
            case Constant.typeName:
                this.visitConstant(statementPart);
                break;
            case NullOperand.typeName:
                this.visitNull(statementPart);
                break;
            case StoredConstant.typeName:
                this.visitStoredConstant(statementPart);
                break;
            case Operator.typeName:
                this.visitOperator(statementPart);
                break;
            case ParameterOperand.typeName:
                this.visitQueryParameter(statementPart);
                break;
            case KnownVariable.typeName:
                this.visitKnownVar(statementPart);
                break;
            case NewVariableOperand.typeName:
                this.visitNewVar(statementPart);
                break;
            case AnotherKPIOperand.typeName:
                this.visitMetric(statementPart);
                break;
            case ConditionalOperand.typeName:
                this.visitIfThenElse(statementPart);
                break;
            case RFunctionOperand.typeName:
                this.visitRFunction(statementPart);
                break;
            case DateDiffBusinessFunctionOperand.typeName:
                this.visitDateDiffBusinessFunction(statementPart);
                break;
            case DateAddBusinessFunctionOperand.typeName:
                this.visitDateAddBusinessFunction(statementPart);
                break;
            case IsBusinessDateFunctionOperand.typeName:
                this.visitIsBusinessDateFunction(statementPart);
                break;
            case UserFilterOperand.typeName:
                this.visitUserFilter(statementPart);
                break;
            case DashboardFilterOperand.typeName:
                this.visitDashboardFilter(statementPart);
                break;
            case SpecialAggregationFunctionOperand.typeName:
                this.visitSpecialAggregationFunction(statementPart);
                break;
        }
    }

    protected visitMath(mathExpression: MathExpression): void {
        _(mathExpression.expressionElements).forEach(e => this.accept(e));
    }

    protected visitSqlFunction(sqlFunction: SQLFunctionOperand): void {
        _(sqlFunction.argumentsStatements).forEach(e => this.accept(e));
    }

    protected visitWhereIn(whereInOperand: WhereInOperand): void {
        this.accept(whereInOperand.expression);
        _(whereInOperand.values).forEach(e => this.accept(e));
    }

    protected visitField(field: FieldOperand): void {}

    protected visitConstant(constant: Constant): void {}

    protected visitNull(nullOperand: NullOperand): void {}

    protected visitStoredConstant(storedConstant: StoredConstant): void {}

    protected visitOperator(operator: Operator): void {}

    protected visitQueryParameter(queryParameter: ParameterOperand): void {}

    protected visitKnownVar(knownVar: KnownVariable): void {}

    protected visitNewVar(newVar: NewVariableOperand): void {
        this.accept(newVar.determinantStatement);
    }

    protected visitMetric(metric: AnotherKPIOperand): void {}

    protected visitIfThenElse(condition: { cases: any; defaultStatement: any }): void {
        _(condition.cases).forEach(c => {
            c.whenStatement && this.accept(c.whenStatement);
            c.thenStatement && this.accept(c.thenStatement);
        });
        condition.defaultStatement && this.accept(condition.defaultStatement);
    }

    protected visitRFunction(rFunction: RFunctionOperand): void {}

    protected visitDateDiffBusinessFunction(dateDiffFunction: DateDiffBusinessFunctionOperand): void {}

    protected visitDateAddBusinessFunction(dateAddFunction: DateAddBusinessFunctionOperand): void {}

    protected visitIsBusinessDateFunction(isBusinessDateFunction: IsBusinessDateFunctionOperand): void {}

    protected visitUserFilter(userFilter: UserFilterOperand): void {}

    protected visitDashboardFilter(userFilter: DashboardFilterOperand): void {}

    protected visitSpecialAggregationFunction(specialAggreationFunction: SpecialAggregationFunctionOperand): void {}
}
